export default __webpack_public_path__ + "static/media/09_include_yourself.38302a37.jpg";